export default (error) => {
  if (error.response || error.request) {
    const { response } = error;
    const { status } = response || {};
    // If response doesn't exist, but request does, the server is down
    const text = response
      ? response.statusText || 'ERROR'
      : 'Unable to connect';
    const { message } = (error.response || {}).data || {};

    return { status, text, message };
  }

  throw error;
};
